// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import getGroupUrl from 'helpers/getGroupUrl'

import EntityAddEditForm from 'js/components/EntityActions/EntityAddEditForm'
import { NotFound } from 'js/core/NotFound'

import { TASKS_LIST } from './Tasks/Tasks.queries'

const Edit = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const params = useParams()
    const { guid } = params

    const { loading, data } = useQuery(TASKS_EDIT, {
        variables: {
            guid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity } = data

    const returnToTaskOverview = () => {
        navigate(`${getGroupUrl(params)}/tasks`, {
            replace: true,
        })
    }

    const refetchQueries = [TASKS_LIST]

    return (
        <EntityAddEditForm
            title={t('entity-task.edit')}
            deleteTitle={t('entity-task.delete')}
            subtype="task"
            entity={entity}
            afterDelete={returnToTaskOverview}
            onClose={returnToTaskOverview}
            refetchQueries={refetchQueries}
        />
    )
}

const TASKS_EDIT = gql`
    query TasksEdit($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Task {
                title
                description
                richDescription
                url
                accessId
                timePublished
                statusPublished
                scheduleArchiveEntity
                scheduleDeleteEntity
                canEdit
                canEditAdvanced
                canEditGroup
                tags
                owner {
                    guid
                    name
                }
                group {
                    guid
                    ... on Group {
                        name
                    }
                }
                isTranslationEnabled
                inputLanguage
            }
        }
    }
`

export default Edit
